import React, { Component } from 'react';
import JobsView from './JobsView';
import { getAllJobs, getAllCategories } from '../../store/models/Jobs/jobsAPI';
import _ from 'lodash';

class JobsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = JobsContainer.getDerivedStateFromProps(props, { loading: true });

    this.handleJobs = this.handleJobs.bind(this);
    this.loadCategories = this.loadCategories.bind(this);
    this.loadAllJobs = this.loadAllJobs.bind(this);
  }

  handleJobs(results) {
    this.setState({
      jobs: results,
    });
    this.setState({ loading: false });
  }

  loadCategories(results) {
    this.setState({
      categories: results,
    });
    this.state.setIsLoaded(true);
  }

  loadAllJobs() {
    const j1 = getAllJobs(this.state.ephemeralKey.bearerToken, 'PENDING');
    const j2 = getAllJobs(this.state.ephemeralKey.bearerToken, 'RUNNING');
    const j3 = getAllJobs(this.state.ephemeralKey.bearerToken, 'FINISHED');
    const j4 = getAllJobs(this.state.ephemeralKey.bearerToken, 'FAILED');

    Promise.all([j1, j2, j3, j4]).then(values => {
      let results = _.flattenDeep(values);
      this.handleJobs(results);
    });
  }

  componentDidMount() {
    if (!this.props.isLoaded) {
      getAllCategories(this.state.ephemeralKey.bearerToken).then(this.loadCategories);
    }

    if (this.state.loading) {
      this.loadAllJobs();
    }
  }

  static getDerivedStateFromProps(props, state) {
    return { ...state, ...props };
  }

  render() {
    const props = { ...this.props };

    return (
        <div className="catJobs" style={{ width: '100%', height: '100%' }}>
          <JobsView {...props} {...this.state} loadAllJobs={this.loadAllJobs} goHome={() => { this.props.history.push('/'); }} />
        </div>
    );
  }
}

export default JobsContainer;